/*
         * @ngdoc function
         * @name ePay.WebApi:AccountTypeWebApi
         * @description
         * Web Api Service
         */
import { forOwn, isPlainObject, isArray } from 'lodash-es';
import { Injectable, NgModule } from "@angular/core";
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ePayService } from './ePayService';
import {
  cloneDeep as _cloneDeep, filter as _filter,
  each as _each, find as _find, remove as _remove,
  forEach as _forEach, isArray as _isArray, findIndex as _findIndex,
  maxBy as _maxBy,
  isNumber
} from 'lodash-es';
import { Observable, of } from 'rxjs';
import { Session_ePaySessionModel } from '../Models/Model/Session_ePaySessionModel';
import { PlatformLocation } from '@angular/common';
import { Session_PreQuestionNumberModel } from '../Models/Model/Session_PreQuestionNumberModel';
import { aspNetControl } from '../Enum/ASPNetControl';
import { typeInfo } from '../Enum/TypeInfo';
import { Session_PreQuestionareModel } from '../Models/Model/Session_PreQuestionareModel';
import { Session_BillingModel } from '../Models/Model/Session_BillingModel';
import { dateInterceptor } from '../Interceptor/dateInterceptor';
import { Session_Credit_Card_ResponseModel } from '../Models/Model/Session_Credit_Card_ResponseModel';
import { Session_Credit_Card_RequestModel } from '../Models/Model/Session_Credit_Card_RequestModel';
import dayjs from 'dayjs';
import { create, all } from 'mathjs';
import { Session_PreQuestionItemModel } from '../Models/Model/Session_PreQuestionItemModel';
import { switchMap } from 'rxjs/operators';

const mathjs = create(all, {});

@Injectable({
  providedIn: 'root',
})
export class formService {
  private iFrameSetting: SafeResourceUrl | null | undefined;
  private basecss: SafeResourceUrl | null | undefined;
  private baseUrl: string;
  private css: SafeResourceUrl | null | undefined;
  public pageNumber: number = 0;
  private ASPNetControl = aspNetControl;
  private TypeInfo = typeInfo;
  private ISO_8601 = /^\d{4}(-\d\d(-\d\d(T\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?$/i;

  constructor(private sanitizer: DomSanitizer,
    public EPayService: ePayService,
    private platformLocation: PlatformLocation
  ) {
    this.baseUrl = this.platformLocation.getBaseHrefFromDOM();
  }

  //Save the session
  public saveSession() {
    console.info('going to unload me');
    if (this.EPayService?.ePay?.xmlPayment.validation.uid) {
      sessionStorage.setItem(this.EPayService.ePay.xmlPayment.validation.uid, JSON.stringify(this.EPayService.ePay));
    }
  }

  //Get the current page
  get CurrentPage(): string {
    if (this.EPayService?.ePay?.page) {
      return this.EPayService.ePay.page;
    }
    return '';
  }

  //Get the agency name
  get AgencyName(): string {
    if (this.EPayService?.ePay?.xmlPayment.agency.agencyName) {
      return this.EPayService.ePay.xmlPayment.agency.agencyName;
    }
    return '';
  }

  //Load the session
  public LoadSession = (sessionId: string, iFrame: boolean): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      var sessionItem = sessionStorage.getItem(sessionId);

      if (this.EPayService.ePay) {
        observer.next(this.EPayService.ePay);
        observer.complete();
      }
      else if (sessionItem) {
        let data = JSON.parse(sessionItem);
        this.LoadSessionData(data);
        observer.next(data);
        observer.complete();
      }
      else {
        this.EPayService.Load(sessionId, iFrame).subscribe(
          (data) => {
            this.LoadSessionData(data);
            this.saveSession();
            observer.next(data);
            observer.complete();
          }
        )
      };
    }
    )
  }

  //Load the session data
  private LoadSessionData = (data: Session_ePaySessionModel) => {
    this.EPayService.ePay = _cloneDeep(data);

    this.isoDateFix(this.EPayService.ePay);

    this.AgencyStyleSheet();
    this.pageNumber = 1;

    if (this.EPayService.ePay.page) {
      if (this.EPayService.ePay.page.startsWith("http")) {
        window.location.href = this.EPayService.ePay.page;
      }
    }
  }

  //Load the questions
  loadPageQuestions = (): Array<Session_PreQuestionNumberModel> => {
    if (this.EPayService.ePay) {
      return _filter(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          return data.pageNumber === this.pageNumber;
        }
      );
    }
    return new Array<Session_PreQuestionNumberModel>();
  }

  //Is first page
  IsFirstPage = () => {
    return this.pageNumber === 1;
  }

  //Is last page
  IsLastPage = () => {
    if (this.EPayService.ePay) {
      let nextPage = _filter(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          if (this.pageNumber) {
            return data.pageNumber === this.pageNumber + 1;
          }
        }
      );

      return nextPage.length == 0;
    }
    return true;
  }

  //Get the last page number
  LastPageNumber = () => {
    if (this.EPayService.ePay) {
      let lastPage = _maxBy(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          return data.pageNumber;
        })

      if (lastPage) {
        return lastPage.pageNumber ? lastPage.pageNumber : 0;
      }
    }
    return 0;
  }

  //Get the next section
  NextSection = (): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      if (this.EPayService.ePay) {
        var currentSection = this.EPayService.ePay.page;
        var nextPage = this.EPayService.NextPage();
        if (nextPage) {
          nextPage.subscribe(
            data => {
              this.EPayService.ePay = _cloneDeep(data);
              window.scrollTo(0, 0);
              if (this.EPayService.ePay.page) {
                if (this.EPayService.ePay.page.startsWith("http")) {
                  window.location.href = this.EPayService.ePay.page;
                  this.EPayService.ePay.page = "redirecting";
                }
              }
              this.saveSession();
              observer.next(this.EPayService.ePay);
              observer.complete();
            }
          )
        }
        else {
          observer.next(this.EPayService.ePay);
          observer.complete();
        }
      }
      else {
        observer.next(new Session_ePaySessionModel());
        observer.complete();
      }
    }
    )
  }

  //Get the previous page
  PreviousPage = (): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      if (this.EPayService.ePay) {
        if (this.EPayService.ePay.page === 'questionnaire') {
          if (this.pageNumber > 1) {
            this.pageNumber = this.pageNumber - 1;
          }
        }
        else if (this.EPayService.ePay.page === 'payment') {
          this.EPayService.ePay.page = 'questionnaire';
          this.pageNumber = this.LastPageNumber();;
        }
        else if (this.EPayService.ePay.page === 'confirmation') {
          this.EPayService.ePay.page = 'payment';
        }
        this.saveSession();
        observer.next(this.EPayService.ePay);
        observer.complete();
      }
      else {
        observer.next(new Session_ePaySessionModel());
        observer.complete();
      }
    });
  }

  //Get the next page
  NextPage = (): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      if (this.IsPageValid()) {
        if (this.EPayService.ePay) {
          let nextPage = _filter(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
            data => {
              return data.pageNumber === this.pageNumber + 1;
            }
          );

          if (nextPage.length > 0) {
            this.pageNumber = this.pageNumber + 1;
            window.scrollTo(0, 0);
            observer.next(this.EPayService.ePay);
            observer.complete();
          }
          else {
            this.CalcuatePaymentAmount().subscribe(
              data => {
                this.EPayService.ePay = _cloneDeep(data);
                this.saveSession();
                this.NextSection().subscribe(
                  data => {
                    this.saveSession();
                    observer.next(data);
                    observer.complete();
                  }
                )
              }
            );
          }
        }
      }
    });
  }

  //Refresh the data
  Refresh = (sessionId: any, config: any): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      this.EPayService.refresh(sessionId, config).subscribe(
        data => {
          if (this.EPayService.ePay) {
            this.EPayService.ePay.xmlPayment = _cloneDeep(data.xmlPayment);
            this.EPayService.ePay.paymentPage = _cloneDeep(data.paymentPage);
          }
          this.saveSession();
          observer.next(data);
          observer.complete();
        }
      );
    });
  }

  //Recaluate the amount
  ReCalculateAmount = (): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      this.CalcuatePaymentAmount().subscribe(
        data => {
          this.saveSession();
          this.EPayService.ePay = _cloneDeep(data);
        }
      );
    });
  }

  //Does this has a questionaire
  HasPreQuestionare = () => {
    if (this.EPayService?.ePay?.xmlPayment.ePayOptions.preQuestionare) {
      return (this.EPayService.ePay.xmlPayment.ePayOptions.preQuestionare.toLowerCase() === "true"
        && this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber.length > 0
      );
    }
    return false;
  }

  PerformPayment = (message: Session_Credit_Card_RequestModel[]): Observable<Session_ePaySessionModel> => {
    if (!message || message.length === 0) {
      // No message, return empty observable
      return of(); // completes immediately
    }

    // Wrap savePayment in an observable
    return this.EPayService.savePayment().pipe(
      switchMap(data => {
        const ePay = this.EPayService?.ePay;
        if (ePay?.paymentPage?.cardData && data?.paymentPage?.cardData?.opaqueData) {
          ePay.paymentPage.cardData.opaqueData = data.paymentPage.cardData.opaqueData;

          if (data.paymentPage.cardData.opaqueData.dataDescriptor === 'captchaFailure') {
            return of(data);
          } else {
            this.saveSession();
            this.EPayService.ePay = _cloneDeep(data);
            return this.NextSection(); // returns Observable<Session_ePaySessionModel>
          }
        } else {
          return of(data);
        }
      })
    );
  };
  ////Perform the payment
  //PeformPayment = (message: Array<Session_Credit_Card_RequestModel>): Observable<Session_ePaySessionModel> => {
  //  return new Observable((observer) => {
  //    if (message) {
  //      //this.EPayService.ePay.paymentPage.token_Request = _cloneDeep(message);
  //      console.info('send me', this.EPayService.ePay);
  //      this.EPayService.savePayment().subscribe(
  //        data => {
  //          if (this.EPayService?.ePay?.paymentPage.cardData && data?.paymentPage?.cardData?.opaqueData) {
  //            this.EPayService.ePay.paymentPage.cardData.opaqueData = data.paymentPage.cardData.opaqueData;
  //            if (data.paymentPage.cardData.opaqueData.dataDescriptor == "captchaFailure") {
  //              observer.next(data);
  //              observer.complete();
  //            }
  //            else {
  //              this.saveSession();
  //              this.EPayService.ePay = _cloneDeep(data);
  //              this.NextSection().subscribe(
  //                data => {
  //                  console.info('loaded data');
  //                  observer.next(data);
  //                  observer.complete();
  //                }
  //              );
  //            }
  //          }
  //          else {
  //            observer.next(data);
  //            observer.complete();
  //          }
  //        }
  //      );
  //    }
  //    else {
  //        return new Observable<Session_ePaySessionModel>(observer => {
  //          // You can either emit nothing and complete:
  //          observer.complete();
  //        });
  //    }
  //  });
  //}

  //Post to apple pay
  postApplePay = (navigateUrl: string) => {
    return this.EPayService.postApplePay(navigateUrl);
  }

  //Post to google pay
  postGooglePay = () => {
    return this.EPayService.postGooglePay();
  }

  //Get the ACH Payment results
  AchPaymentResults = (): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      this.EPayService.savePayment().subscribe(
        data => {
          if (this.EPayService?.ePay?.paymentPage.cardData && data?.paymentPage?.cardData?.opaqueData) {
            this.EPayService.ePay.paymentPage.cardData.opaqueData = data.paymentPage.cardData.opaqueData;
            if (data.paymentPage.cardData.opaqueData.dataDescriptor == "captchaFailure") {
              observer.next(data);
              observer.complete();
            }
            else {
              this.saveSession();
              this.EPayService.ePay = _cloneDeep(data);
              this.NextSection().subscribe(
                data => {
                  this.saveSession();
                  observer.next(data);
                  observer.complete();
                }
              );
            }
          }
          else {
            observer.next(data);
            observer.complete();
          }
        }
      );
    });
  }

  //Remove the recurring billing
  RemoveBillingPaymentResults = (Billing: Session_BillingModel): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      this.EPayService.UnStore().subscribe(data => {
        this.saveSession();
        this.EPayService.ePay = _cloneDeep(data);
        observer.next(data);
        observer.complete();
      })
    });
  }

  //Post a recurring billing
  BillingPaymentResults = (Billing: Session_BillingModel): Observable<Session_ePaySessionModel> => {
    return new Observable((observer) => {
      if (Billing) {
        if (Billing.expMonth) {
          if (Billing.expMonth.length < 2) {
            Billing.expMonth = '0' + Billing.expMonth;
          }
          if (Billing.expMonth.length > 2) {
            Billing.expMonth = Billing.expMonth.substring(0, 1);
          }
        }
        if (Billing.expYear) {
          if (Billing.expYear.length < 2) {
            Billing.expYear = '0' + Billing.expYear;
          }
          if (Billing.expYear.length > 2) {
            Billing.expYear = Billing.expYear.substr(Billing.expYear.length - 2, 2);
          }
        }
      }

      //this.EPayService.ePay.paymentPage.trustCommerce.exp = Billing.expMonth + Billing.expYear
      //this.EPayService.ePay.paymentPage.trustCommerce.action_name = "stored";
      //this.EPayService.ePay.paymentPage.trustCommerce.billingId = Billing.billingId
      this.EPayService.savePayment().subscribe(
        data => {
          this.saveSession();
          this.EPayService.ePay = _cloneDeep(data);
          this.NextSection().subscribe(
            data => {
              observer.next(data);
              observer.complete();
            }
          );
        }
      );
    });
  }

  //Calcuate the payment amount
  private CalcuatePaymentAmount = () => {
    return this.EPayService.CalcuatePaymentAmount();
  }

  //Get the agency style to overload
  AgencyStyleSheet = () => {
    if (this.EPayService.ePay) {
      var css = this.EPayService.ePay.xmlPayment.ePayOptions.css;
      //console.log('override css', css);
      if (!css) {
        css = this.EPayService.ePay.xmlPayment.agency.css;
      }
      if (css) {
        if (!this.css) {
          let url = this.baseUrl + '/CSS.ashx?CSS=' + css;
          url = url.replace("//", "/");
          this.css = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
        return this.css;
      }
    }
  }

  //Get all of the questions
  private AllQuestions = (): Array<Session_PreQuestionNumberModel> => {
    if (this.EPayService.ePay) {
      return this.allQuestions(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber);
    }
    return new Array<Session_PreQuestionNumberModel>();
  }

  //Get all of the questions
  private allQuestions = (itemquestions: Array<Session_PreQuestionNumberModel>): Array<Session_PreQuestionNumberModel> => {
    let questions = new Array<Session_PreQuestionNumberModel>();

    _each(itemquestions,
      (item) => {
        questions.push(item);
        if (item.aspNetControlId === this.ASPNetControl.Repeating_Section) {
          _each(this.allQuestions(item.preQuestionNumber), (q) => {
            questions.push(q);
          });
        }
      }
    );

    return questions;
  }

  //Calculate the amount based on the questions
  Calculate = (questions: Array<Session_PreQuestionNumberModel>, scope: any) => {
    _each(questions,
      (item) => {
        //default all items to 0
        this.addLineItem(scope, item.number, 0);

        if (item.aspNetControlId === this.ASPNetControl.CheckBoxList) {
          _each(item.preQuestionItem, (itm) => {
            if (itm.value === true) {
              this.addLineItem(scope, item.number, itm.changeTotal);
            };
          });
        }
        else if (item.aspNetControlId === this.ASPNetControl.DropDownList) {
          if (item.value) {
            const foundItem = item.preQuestionItem.find(
              itm => itm.genID?.toString() === item.value.toString()
            );
            if (foundItem?.changeTotal) {
              this.addLineItem(scope, item.number, foundItem.changeTotal);
            }
          }
        }
        else if (item.aspNetControlId === this.ASPNetControl.Hidden) {
          if (item.typeId === this.TypeInfo.Required_Amount ||
            item.typeId === this.TypeInfo.Currency ||
            item.typeId === this.TypeInfo.Number_As_Currency ||
            item.typeId === this.TypeInfo.Whole_Number ||
            item.typeId === this.TypeInfo.Number) {
            if (item.value) {
              this.addLineItem(scope, item.number, item.value);
            }
            else {
              this.addLineItem(scope, item.number, item.amount);
            }
          }
        }
        else if (item.aspNetControlId === this.ASPNetControl.Label) {
          if (item.typeId === this.TypeInfo.Number_As_Currency) {
            if (item.value) {
              this.addLineItem(scope, item.number, item.value);
            }
            else {
              this.addLineItem(scope, item.number, item.amount);
            }
          }
        }
        else if (item.aspNetControlId === this.ASPNetControl.RadioButtonList) {
          if (item.value) {
            let foundItem = _find(item.preQuestionItem, (itm) => {
              return itm.genID?.toString() === item.value.toString();
            }
            )
            if (foundItem) {
              this.addLineItem(scope, item.number, foundItem.changeTotal);
            }
          }
        }
        else if (item.aspNetControlId === this.ASPNetControl.TextBox) {
          if (item.typeId === this.TypeInfo.Required_Amount ||
            item.typeId === this.TypeInfo.Currency ||
            item.typeId === this.TypeInfo.Number_As_Currency ||
            item.typeId === this.TypeInfo.Whole_Number ||
            item.typeId === this.TypeInfo.Number) {
            this.addLineItem(scope, item.number, item.value);
          }
        }
        else if (item.aspNetControlId === this.ASPNetControl.User_Defined_Amount) {
          this.addLineItem(scope, item.number, item.value);
        }

        if (item.aspNetControlId === this.ASPNetControl.Repeating_Section) {
          _each(item.preQuestionNumber, (itm) => {
            this.Calculate(itm.preQuestionNumber, scope);
          })
        }
      }
    )
  }

  //Calculate the amount based on the questions
  Calculation = () => {
    let questions = this.AllQuestions();

    let scope = {
    };

    //Refresh scope in case of value change
    this.Calculate(questions, scope);

    _each(questions, (question, key) => {
      let tempScope = {};

      if (question.index) {
        //Limit scope to parent group
        let newScope = {
        }
        let subQuestions = _filter(questions,
          (q) => {
            return q.group === question.group && q.index === question.index
          }
        );

        this.Calculate(subQuestions, newScope);
        tempScope = _cloneDeep(newScope);
      }
      else {
        tempScope = _cloneDeep(scope);
      }
      this.evaluateFormula(question, tempScope);
    });
  }

  //Evalute the value base on formula
  evaluateFormula = (question: Session_PreQuestionNumberModel, scope: object) => {
    try {
      if (question.formula) {
        console.info('eval', question.formula, scope)
        question.value = mathjs.evaluate(question.formula, scope);
        question.formulaEval = question.value;

        if (question.typeId == this.TypeInfo.Number_As_Currency) {
          question.amount = question.value;
        }
      }
    }
    catch (e) {
    }
  }

  //Add item for segregating the groups
  addLineItem(scope: any, lineNumber: number | null | undefined, amount: number | null | undefined) {
    if (lineNumber != null) {
      if ((scope["Line" + lineNumber.toString()])) {
        scope["Line" + lineNumber.toString()] = scope["Line" + lineNumber.toString()] + amount;
      }
      else {
        scope["Line" + lineNumber] = amount;
      }
    }
  }

  //Remove a group
  removegroup = (itemquestions: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel>) => {
    if (itemquestions) {
      let foundItem = _find(preQuestionItems, (itm) => {
        return itm === itemquestions;
      }
      );

      if (foundItem) {
        _remove(preQuestionItems,
          (item) => {
            return item.index === foundItem.index;
          });
      }
    }
  }

  //Add a group
  addgroup = (itemquestions: Session_PreQuestionNumberModel) => {
    if (itemquestions) {
      if (itemquestions.group) {
        var index = 0;
        _find(itemquestions.group, (indexitem) => {
          if (indexitem.index) {
            if (indexitem.index > index) {
              index = indexitem.index;
            }
          }
        })
        index = index + 1;

        _each(itemquestions.group, (item) => {
          item.index = index;
          itemquestions.preQuestionNumber.push(_cloneDeep(item));
        }
        )
      }
    }
  }

  //Is last item in group
  isLastItemInGroup = (itemquestions: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel>): boolean => {
    if (itemquestions && preQuestionItems) {
      let foundIndex = _findIndex(preQuestionItems, itemquestions);
      if (foundIndex) {
        let foundItem = preQuestionItems[foundIndex];

        if (foundItem.index) {
          if (preQuestionItems.length - 1 === foundIndex) {
            return true
          }
          else {
            if (foundIndex < preQuestionItems.length - 1) {
              let nextItem = preQuestionItems[foundIndex + 1];
              return foundItem.index !== nextItem.index;
            }
          }
        }
      }
    }
    return false;
  }

  //Is the first item in the group
  isFirstItemInGroup = (itemquestions: Session_PreQuestionNumberModel, preQuestionItems: Array<Session_PreQuestionNumberModel>): boolean => {
    let foundIndex = _findIndex(preQuestionItems, itemquestions);
    let foundItem = _find(preQuestionItems, (itm) => {
      return itm === itemquestions;
    }
    );

    if (foundItem) {
      if (foundItem.index) {
        if (foundIndex === 0) {
          return true
        }
        else {
          if (foundIndex > 0) {
            let previousItem = preQuestionItems[foundIndex - 1];
            return foundItem.index !== previousItem.index;
          }
        }
      }
    }
    return false;
  }

  //Is the page valid
  IsPageValid = () => {
    let invalids = this.isPageValid(this.loadPageQuestions()) || new Array<Session_PreQuestionNumberModel>();
    return invalids.length === 0;
  }

  //Is the page valid
  isPageValid = (preQuestionNumber: Array<Session_PreQuestionNumberModel>): Array<Session_PreQuestionNumberModel> => {
    let invalids = new Array<Session_PreQuestionNumberModel>();

    _forEach(preQuestionNumber,
      data => {
        if (data.aspNetControlId === this.ASPNetControl.Repeating_Section) {
          _forEach(this.isPageValid(data.preQuestionNumber),
            cdata => {
              invalids.push(cdata);
            });
        }
        if (!data.valid && data.pageNumber === this.pageNumber) {
          invalids.push(data);
        }
      });
    return invalids;
  }

  //Is the form valid
  IsFormValid = () => {
    let invalids = this.isFormValid(this.loadPageQuestions()) || new Array<Session_PreQuestionNumberModel>();
    return invalids.length === 0;
  }

  //Is the form valid
  isFormValid = (preQuestionNumber: Array<Session_PreQuestionNumberModel>): Array<Session_PreQuestionNumberModel> => {
    let invalids = new Array<Session_PreQuestionNumberModel>();

    _forEach(preQuestionNumber,
      data => {
        if (data.aspNetControlId === this.ASPNetControl.Repeating_Section) {
          _forEach(this.isFormValid(data.preQuestionNumber),
            cdata => {
              invalids.push(cdata);
            });
        }
        if (!data.valid) {
          invalids.push(data);
        }
      });
    return invalids;
  }

  //Check the size of the data for a drop down list
  sizeLimit = () => {
    if (this.EPayService.ePay) {
      _each(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          if (data.size && data.value) {
            if (data.value.toString().length > data.size && !dayjs(<string>data.value).isValid()) {
              if (Number(data.value).toString() == data.value.toString()) {
                data.value = Number(data.value.toString().substring(0, data.size));
              }
              else {
                data.value = data.value.toString().substring(0, data.size);
              }
            }
          }
        }
      );
    }
  }

  //Validate the page
  validate = () => {
    if (this.EPayService?.ePay?.xmlPayment.preQuestionare.preQuestionNumber) {
      _each(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          this.validateData(data);

          if (data.aspNetControlId === this.ASPNetControl.Repeating_Section) {
            _each(data.preQuestionNumber, (sdata) => {
              this.validateData(sdata);
            });
          }
        }
      );
    }
  }

  //Get the error message
  errorMessage = (item: Session_PreQuestionNumberModel) => {
    let message = '';
    _each(
      item.preQuestionItem,
      (data) => {
        if (!data.valid && data.errorMessage) {
          message = message + data.errorMessage;
        }
      });
    return message;
  }

  //Get the error messages
  errorMessages = () => {
    let messages: string[] = [];

    if (this.EPayService?.ePay?.xmlPayment.preQuestionare.preQuestionNumber) {
      _each(this.EPayService.ePay.xmlPayment.preQuestionare.preQuestionNumber,
        data => {
          if (!data.valid && data.errorMessage && data.value) {
            messages.push(data.errorMessage);
          }
        });
    }
    //console.info('messages', messages);
    return messages;
  }

  //Validate the question
  private validateData = (data: Session_PreQuestionNumberModel) => {
    data.valid = true;
    if (data.required) {
      if (data.aspNetControlId === this.ASPNetControl.CheckBoxList) {
        //Handle check boxes at least 1 must be true
        let check = _filter(data.preQuestionItem,
          item => {
            return item.value;
          }
        );
        data.valid = check.length > 0;
      }
      else if (data.aspNetControlId === this.ASPNetControl.Repeating_Section) {
        data.valid = data.preQuestionNumber.length > 0
      }
      else {
        if (data.value === null || data.value === '') {
          data.valid = false;
        }
      }
    }

    if (this.pageNumber === data.pageNumber) {
      if (data.aspNetControlId === this.ASPNetControl.CheckBoxList) {
        let required_Answer = _filter(data.preQuestionItem,
          item => {
            return item.required_Answer;
          }
        );

        if (required_Answer.length > 0) {
          let result = _find(required_Answer, (ra: Session_PreQuestionItemModel) => {
            return ra.value;
          });

          let check = _filter(data.preQuestionItem,
            item => {
              return item?.value;
            }
          );

          if (!result && check.length > 0) {
            data.valid = false;
          }
        }
      }

      if (data.aspNetControlId === this.ASPNetControl.RadioButtonList || data.aspNetControlId === this.ASPNetControl.DropDownList) {
        let required_Answer = _filter(data.preQuestionItem,
          item => {
            if (item.required_Answer != null) {
              return item;
            }
          }
        );
        
        if (required_Answer.length > 0) {
          //Assume all is valid
          //See if the selected item matches a required field
          let result = _find(required_Answer, (ra: Session_PreQuestionItemModel) => {
            if (data.value === null || ra.genID === null) {
              return false;
            }
            else {
              return data.value.toString() === ra.genID?.toString();
            }
          });
          if (!result && data.value) {
            data.valid = false;
            _each(data.preQuestionItem,
              (pi) => {
                if (data.value === null || pi === null) {
                  pi.valid = false;
                }
                else {
                  pi.valid = (data.value.toString() !== pi.genID?.toString());
                }
              }
            )
          }
          else {
            _each(data.preQuestionItem,
              (pi) => {
                pi.valid = true;
              }
            )
          }
        }
      }
    }

    if (data.aspNetControlId === this.ASPNetControl.Repeating_Section) {
      _each(data.preQuestionNumber,
        (item) => {
          this.validateData(item);
        }
      );
    }
  }

  //Select item in a drop down list
  selectItemValue = (item: Session_PreQuestionNumberModel) => {
    if (item.value) {
      let sitem = _find(item.preQuestionItem,
        itm => {
          return itm.genID === item.value;
        });
      if (sitem) {
        return sitem.screenValue;
      }
    }
    return "";
  }

  //Calculate width of the popup based on the character length
  popupWidth = (array: Array<any>, property: string) => {
    let maxLength: number = 0;
    if (_isArray(array)) {
      if (array.length > 0) {
        _forEach(array, data => {
          if (data[property]) {
            if (data[property].toString().length > maxLength) {
              maxLength = data[property].toString().length;
            }
          }
        })
      }
    }

    if (maxLength === 0) {
      return 'auto'
    }
    else {
      if (maxLength * 8 + 10 > screen.availWidth) {
        return screen.availWidth - 10;
      }
      else {
        if (maxLength * 8 + 10 < 60) {
          return 60;
        }
        else {
          return maxLength * 8 + 10;
        }
      }
    }
  }

  deviceConnect(hsn: string | null) {
    return this.EPayService.deviceConnect(hsn);
  }

  deviceCharge() {
    return this.EPayService.deviceCharge();
  }

  manualCharge() {
    return this.EPayService.manualCharge();
  }

  deviceCancelRequest() {
    return this.EPayService.deviceCancelRequest();
  }

 isoDateFix(object: any) {
  forOwn(object, (value, key, obj) => {
    if (isPlainObject(value) || isArray(value)) {
      this.isoDateFix(value);
    } else if (value && typeof value === 'string') {
      if (this.ISO_8601.test(value) && dayjs(value).isValid()) {
        obj[key] = dayjs(value).toDate();
      }
    }
  });
}
}
